import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";
import { SessionStorage } from "../storage";

interface ContextProps {
    nextStep: (data: IRegisterData) => void,
    step: number,
    partners: string[],
    getData: () => Promise<IRegisterData>,
    loading: boolean,
    setLoading: (value: boolean) => void
}

export interface IRegisterData {
    first?: {
        cnpj: string,
        partners: string[]
    },
    second?: {
        name: string,
        cpf: string,
        birthday: string
    },
    third?: {
        address: {
            street: string,
            number: string,
            district: string,
            city: string,
            cep: string,
            uf: string,
            complement?: string,
            reference?: string,
        },
        email: string,
        phone: string
    },
    fourth?: {
        token: string,
        role: number,
        userId: string
    }
}

export const RegisterManager = createContext({} as ContextProps);

const useRegister = () => useContext(RegisterManager);

export const RegisterProvider = ({ children }: { children: React.ReactNode }) => {
    const [step, setStep] = useState<number>(0)
    const [loading, setLoading] = useState(false)

    const [partners, setPartners] = useState<string[]>([])

    const nextStep = async (data: IRegisterData) => {
        const currentData = await SessionStorage.getRegisterData()
        SessionStorage.saveRegister({
            ...currentData,
            ...data,
        })
        setStep(step + 1)
        if (data?.first?.partners) setPartners(data?.first?.partners)
    }

    const getData = async (): Promise<IRegisterData> => {
        return SessionStorage.getRegisterData()
    }

    useEffect(() => {
        (async () => {
            const _step = await SessionStorage.getStep()
            if (_step) setStep(Number(_step))

            const data = await SessionStorage.getRegisterData()
            if (data?.first?.partners) setPartners(data?.first?.partners)
        })()
    }, [])

    useEffect(() => {
        SessionStorage.saveStep(step)
        scrollToTop()
    }, [step])


    const scrollToTop = () => {
        const scrollableElement = document.getElementById('container-layout'); // Pegue o elemento pelo ID
        if (scrollableElement) {
            scrollableElement.scrollTo({ top: 0, behavior: 'smooth' }); // Rola para o topo
        }
    }

    return (
        <RegisterManager.Provider value={{
            nextStep,
            step,
            partners,
            getData,
            loading,
            setLoading
        }}>
            {children}
        </RegisterManager.Provider>
    )
}

export default useRegister;